import { useState } from "react";
import cn from "classnames";
import { Grid } from "@material-ui/core";
import { DataGrid, DataGridProps, GridCellParams } from "@material-ui/data-grid";
import { createStyles, makeStyles } from "@material-ui/styles";
import StretchedDataGrid from "./StretchedDataGrid";
import Pagination from "./Pagination";
import ChildrenElement from "../../models/HelperModels/ChildrenElement";

import classes from './index.module.scss';

// todo: review these styles
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      maxHeight: '50vh',
      minHeight: '100%',
      fontSize: '14px',
      '& .MuiDataGrid-columnSeparator': {
        color: 'transparent',
        width: '0px',
      },
      '& .MuiDataGrid-columnHeader': {
        fontWeight: 500,
        fontSize: '14px',
        margin: 'auto',
      },
      '& .MuiDataGrid-cell': {
        wordWrap: 'break-word',
        padding: '0 12px',
      },
      '& .MuiDataGrid-columnHeaderTitleContainer:first-child': {},
      '& .MuiDataGrid-columnHeaderTitleContainer': {},
      '& .MuiDataGrid-checkboxInput': {
        width: '15px',
        height: '15px',
      },
    },
  })
);

export type StyledDataGridType = {
  autoWidth?: boolean;
  noPagination?: boolean;
  hideHorizontalScroll?: boolean;
} & DataGridProps;

const MAX_ROW_PER_PAGE = 100;

const StyledDataGrid = ({ autoWidth, noPagination, hideHorizontalScroll = false, ...props }: StyledDataGridType) => {
  const styles = useStyles();
  const [ currentPage, setCurrentPage ] = useState(0);

  const rowCount = props.rows.length;
  const hasPagination = rowCount >= MAX_ROW_PER_PAGE;
  let pagination: ChildrenElement = null;

  if (hasPagination) {
    pagination = (
      <Grid item xs={12}>
        <Pagination
          currentPage={currentPage}
          pageSize={MAX_ROW_PER_PAGE}
          itemsCount={rowCount}
          pageCount={Math.ceil(rowCount / MAX_ROW_PER_PAGE)}
          increasePage={() => setCurrentPage(currentPage + 1)}
          decreasePage={() => setCurrentPage(currentPage - 1)}
        />
      </Grid>
    )
  }

  if (noPagination) {
    if (autoWidth) {
      return (
        <StretchedDataGrid
          hideFooter={true}
          onCellClick={(params: GridCellParams) => {
            params.hasFocus = false;
          }}
          onRowClick={() => {}}
          onCellBlur={() => {}}
          classes={styles}
          {...props}
        />
      )
    }

    return (
      <DataGrid
        hideFooter={true}
        onCellClick={(params: GridCellParams) => {
          params.hasFocus = false;
        }}
        onRowClick={() => {}}
        onCellBlur={() => {}}
        classes={styles}
        {...props}
      />
    )
  }

  if (autoWidth) {
    return (
      <Grid
        container
        className={cn(classes.container, {
          [classes.containerWithPagination]: hasPagination
        })}
      >
        <StretchedDataGrid
          hideFooter={true}
          onCellClick={(params: GridCellParams) => {
            params.hasFocus = false;
          }}
          onRowClick={() => {}}
          onCellBlur={() => {}}
          classes={styles}
          page={currentPage}
          pageSize={MAX_ROW_PER_PAGE}
          {...props}
        />
        {
          pagination
        }
      </Grid>
    )
  }

  return (
    <Grid
      container
      className={cn(classes.container, {
        [classes.containerWithPagination]: hasPagination
      })}
    >
      <Grid item xs={12}>
        <DataGrid
          hideFooter={true}
          onCellClick={(params: GridCellParams) => {
            params.hasFocus = false;
          }}
          onRowClick={() => {}}
          onCellBlur={() => {}}
          classes={styles}
          page={currentPage}
          pageSize={MAX_ROW_PER_PAGE}
          {...props}
        />
      </Grid>
      {
        pagination
      }
    </Grid>
  );
}

export default StyledDataGrid;